import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { Observable, forkJoin, of } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { switchMap, map, startWith, catchError } from 'rxjs/operators';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AngularCsv } from 'angular7-csv';
import jsPDF from 'jspdf';
import 'jspdf-autotable'
import autoTable, { UserOptions } from 'jspdf-autotable'
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { AppDateAdapter, APP_DATE_FORMATS } from 'src/app/common/format-datepicker';
import { Employee } from '../../../models/employee.model';
import { CompanyTraining } from '../../../models/companytraining.model';
import { CompanyTrainingPrintReportFilter } from '../../../models/company-training-print-report-filters.model';
import { SystemCode } from '../../../models/system-codes.model';
import { RolePermissionCheck } from '../../../models/role-permission-check.model';
import { GlobalConstants } from '../../../common/global-constants';
import { AuthService } from '../../../services/auth.service';
import { SystemCodeService } from '../../../services/system-code.service';
import { EmployeeService } from '../../../services/employee.service';
import { CompanyTrainingService } from '../../../services/companytraining.service';
import { GetAllCompanyTraining } from '../../../models/get-all-companyTraining.model';
import { DeleteDialogComponent } from '../../../common/delete-dialog/delete-dialog.component';
import { ModelDialogContent } from '../../../common/model-dialog/model-dialog-content';
import { GearRequest } from '../../../models/gearrequest.model';
import { GetAllGearRequestModel } from '../../../models/get-all-gear-request.model';
import { GearRequestService } from '../../../services/gearrequest.service';
import { GearRequestSearchResultModel } from '../../../models/gear-request-search-result.model';

interface EmployeeFilter {
  employeeId: number;
  name: string;
}

@Component({
  selector: 'gear-request-report',
  templateUrl: './gear-request-report.component.html',
  styleUrls: ['./gear-request-report.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
  ]
})
export class GearRequestReportComponent {
  @ViewChild('gearRequestForm', { static: false }) gearRequestForm: NgForm;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  employeesList: Employee[] = [];
  gearRequestObj: GearRequest;
  companyTrainingPrintReportFilters: CompanyTrainingPrintReportFilter;
  emstrainingReportList: GearRequestSearchResultModel[] = [];
  stopDate: null;
  employeeNames: string[] = [];
  employee: EmployeeFilter;
  sortid: MatSort;
  employeeResutObj: Employee[] = [];
  public filteredList5: Employee[] = [];
  resultsLength: number = 0;
  fontName: string = GlobalConstants.fontName;
  fontSize: number = GlobalConstants.fontSize;
  headSize: number = GlobalConstants.headingSize;
  footerFontSize: number = GlobalConstants.footerFontSize;
  @BlockUI() blockUI: NgBlockUI;
  dataSource: MatTableDataSource<GearRequestSearchResultModel>;
  paginatorid: MatPaginator;
  displayedColumns: any[] = ['crew', 'requestDate', 'lastName', 'replacementOrRepair', 'reason', 'gearType', 'email', 'gearStatus'];
  startMaxDate: Date;
  endMinDate: Date;
  rolePermissionCheckModel: RolePermissionCheck;
  //isViewReport: boolean = false;
  endDateDisable: boolean = false;
  isInitialLoad: boolean = true;
  floatLabel: string = 'never';
  gearRequests: Array<GearRequestSearchResultModel> = [];
  totalHours: number = 0;
  crews: SystemCode[] = [];
  replaceorrepairs: SystemCode[] = [];
  geartypes: SystemCode[] = [];
  constructor(
    private dialog: MatDialog, private routerService: Router,
    private route: ActivatedRoute, private systemCodeStateService: SystemCodeService,
    private authService: AuthService, private gearRequestService: GearRequestService,
    private employeeService: EmployeeService,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.rolePermissionCheckModel = this.route.snapshot.data['rolePermissions'];
  }

  ngOnInit() {
    if (this.rolePermissionCheckModel && this.rolePermissionCheckModel.isRead) {
      this.initializeActionsForDisplayedColumns();
      this.gearRequestObj = this.initializeCompanyTrainingModel();
      this.companyTrainingPrintReportFilters = this.initializeCompanyTrainingPrintReportFilters();
      this.dataSource = new MatTableDataSource(this.emstrainingReportList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.loadDropDowns();
      this.startMaxDate = new Date("12/30/2100");
      this.endMinDate = new Date("12/30/1900");
      this.loadGrid();
      //this.dataSource.sort = this.sort;
    }
  }

  initializeActionsForDisplayedColumns(): void {
    if (this.rolePermissionCheckModel.isUpdate) {
      this.displayedColumns.push('edit');
    }
    if (this.rolePermissionCheckModel.isDelete) {
      this.displayedColumns.push('delete');
    }
    if (this.rolePermissionCheckModel.isRead) {
      this.displayedColumns.push('view');
    }
  }

  /*********************************** */
  ngAfterViewInit() {
    this.InitialLoad();
  }

  InitialLoad() {
    if (this.rolePermissionCheckModel && this.rolePermissionCheckModel.isRead) {
      //pagination subscription
      this.paginator.page
        .pipe(
          startWith({}),
          switchMap(() => {
            this.blockUI.start();
            return this.getAllGearRequest(this.paginator.pageIndex, this.paginator.pageSize);
          }),
          map(data => {
            this.blockUI.stop();
            this.resultsLength = data.totalCount;
            return data.items;
          }),
          catchError(() => {
            this.blockUI.stop();
            return of([]);
          })
        ).subscribe(data => {
          console.log(data);
          this.emstrainingReportList = data || [];
          this.dataSource = new MatTableDataSource(this.emstrainingReportList);
          this.dataSource.sort = this.sort;
          this.blockUI.stop();
        });
    }
  }

  getAllGearRequest(pageIndex: number, pageSize: number): Observable<GetAllGearRequestModel> {

    //let loc = (this.gearRequestObj.location != null && this.gearRequestObj.location != undefined) ? this.gearRequestObj.location : "0";

    return this.gearRequestService.searchGearRequest(
      'SearchGearRequest',
      (this.gearRequestObj.crew) ? this.gearRequestObj.crew : 0,
      (this.gearRequestObj.replaceOrRepair) ? this.gearRequestObj.replaceOrRepair : 0,
      (this.gearRequestObj.lastName) ? this.gearRequestObj.lastName : '',
      (this.gearRequestObj.gearType) ? this.gearRequestObj.gearType : 0,
      (this.gearRequestObj.startDate) ? this.gearRequestObj.startDate : null,
      (this.gearRequestObj.endDate) ? this.gearRequestObj.endDate : null,
      pageIndex,
      pageSize,
      false
    );
  }

  getAllCompanyTrainingForDataSource(): void {
    this.blockUI.start();
    this.getAllGearRequest(0, 15)
      .pipe(
        map(data => {
          this.resultsLength = data.totalCount;
          return data.items;
        }),
        catchError(() => {
          this.blockUI.stop();
          return of([]);
        })
    ).subscribe(data => {
      console.log(data);
      this.emstrainingReportList = data;
        this.dataSource = new MatTableDataSource(this.emstrainingReportList);
        this.blockUI.stop();
        this.dataSource.sort = this.sort;
      });
  }

  /*********************************** */

  initializeCompanyTrainingModel(): GearRequest {
    return {
      comments: null,
      crew: null,
      email: null,
      gearRequestId: 0,
      gearStatus: null,
      gearType: 0,
      helmetPartsCheck: false,
      lastName: null,
      othersCheck: false,
      othersDesc: null,
      reason: null,
      replaceOrRepair: 0,
      requestDate: null,
      requestDateStr: null,
      specificNeed:null   
    } as GearRequest;
  }

  initializeCompanyTrainingPrintReportFilters(): CompanyTrainingPrintReportFilter {
    return {
      trainingType: null,
      employeeName: null,
      category: null,
      crewName: null,
      stationName: null,
      startDate: null,
      endDate: null
    } as CompanyTrainingPrintReportFilter;
  }

  public loadDropDowns() {
    forkJoin(
      this.systemCodeStateService.getSystemCodesForCrews(),
      this.employeeService.getAllEmployees('GetEmployees', 0),
      this.systemCodeStateService.getAllReplaceOrRepairs(),
      this.systemCodeStateService.getAllGearTypes(),
    ).subscribe(([res1, res2,res3,res4]) => {
      this.crews = res1 || [];
      this.employeeResutObj = res2 || [];
      this.replaceorrepairs = res3 || [];
      this.geartypes = res4 || [];
    });
  }


  searchReport() {
    this.isInitialLoad = false;
    this.getAllCompanyTrainingForDataSource();
  }

  resetCompanyTraining() {
    this.isInitialLoad = true;
    this.gearRequestForm.resetForm();
    this.gearRequestObj = this.initializeCompanyTrainingModel();
    this.paginator.pageIndex = 0;
    this.paginator.pageSize = 15;
    this.startMaxDate = null;
    this.endMinDate = null;
    this.gearRequests = [];
    this.getAllCompanyTrainingForDataSource();
  }


  deletegearRequest(eId: string) {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      data: {
        id: 1
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res == 1) {
        // this.employeeObj.employeeId = parseInt( eId);
        this.gearRequestService.deleteGearRequest('DeleteGearRequest', parseInt(eId)).subscribe(res => {
          this.getAllCompanyTrainingForDataSource();
          // this.trainingReport();
          // this.InitialLoad();
        });
      }
    });
    return false;
  }

  openPopup(companyTrainingId: number) {
    //this.companyTrainingService.getCompanyTraining('getCompanyTraining', companyTrainingId).subscribe(res => {
    //  this.employeeNames = res.employeeNames;
    //  this.openDialog(this.employeeNames);
    //});
  }

  openDialog(nameList: any) {
    const dialogRef = this.dialog.open(ModelDialogContent, {
      data: {
        names: nameList
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  loadGrid() {
    this.employeeService.getAllEmployees('GetEmployeesFromCompanyTraining', 0).subscribe(res => {
      let empObj: any = res;
      this.employeeResutObj = empObj.map(x => { return { employeeId: x.employeeId, value: x.lastName + ', ' + x.firstName }; });
      this.employeesList = empObj;
      this.filteredList5 = this.employeeResutObj.slice();
    }, (err: any) => { }
    );
  }

  startDateChange(dt: Date) {
    this.endMinDate = new Date(dt);
    this.endDateDisable = true;
    if (dt == null) {
      this.gearRequestObj.endDate = null;
      this.endDateDisable = false;
    }
  }
  goHome(): void {
  

    this.routerService.navigate(['/home']);
  }

  editGearRequestForm(id: number) {
    if (id > 0) {
      this.routerService.navigate(['/updategearrequestform', { id: id }]);
    }
  }

  showGearRequestReport(): void {
    this.totalHours = 0;
    this.blockUI.start();
    this.gearRequestService.searchGearRequest(
      'SearchGearRequest',
      (this.gearRequestObj.crew) ? this.gearRequestObj.crew : 0,
      (this.gearRequestObj.replaceOrRepair) ? this.gearRequestObj.replaceOrRepair : 0,
      (this.gearRequestObj.lastName) ? this.gearRequestObj.lastName : '',
      (this.gearRequestObj.gearType) ? this.gearRequestObj.gearType : 0,
      (this.gearRequestObj.startDate) ? this.gearRequestObj.startDate : null,
      (this.gearRequestObj.endDate) ? this.gearRequestObj.endDate : null,
      0, 15, true
    ).subscribe((res: GetAllGearRequestModel) => {
      this.gearRequests = res.items;
      this.blockUI.stop();
      this.setPDF();
    }, (error: any) => {
      this.gearRequests = [];
      this.blockUI.stop();
    });
  }

  setPDF(): void {
    debugger;
    let yAxis: number = 30;
    var doc = new jsPDF('l', 'mm', 'letter');
    doc.setFont(this.fontName);
    let pdfTitle = 'Gear Request Report';
    let footerSize = this.footerFontSize;
    var pageno = 0;
    var nooftime = 0;
    var pagetotal = 0;
    var overalltotal = this.totalHours;
    doc.setProperties({
      title: pdfTitle
    });

    var totalPagesExp = '{total_pages_count_string}';
    doc.setTextColor(40)
    doc.setFontSize(this.headSize)
    var textWidth = doc.getStringUnitWidth(pdfTitle) * doc.getFontSize() / doc.internal.scaleFactor;
    var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
    doc.text(pdfTitle, textOffset, 20)
    doc.setFontSize(this.fontSize)

    //Setting the Filter to display on the PDF

    autoTable(doc, {
      rowPageBreak: 'avoid',
      columnStyles: {
        startTime: {
          cellWidth: 20,
          halign: 'right'
        },
        endTime: {
          cellWidth: 20,
          halign: 'right'
        },
        hours: {
          halign: 'right'
        }
      },
      headStyles: { minCellHeight: 8, fillColor: '#ff4242', font: this.fontName, fontStyle: 'bold', fontSize: this.fontSize },
      bodyStyles: { minCellHeight: 8, fillColor: null, font: this.fontName, fontSize: this.fontSize },
      head: this.getHeadRows(),
      body: this.getBody(),
      didDrawPage: function (data) {
        // Footer
        var str = 'Page ' + doc.getNumberOfPages()
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
          str = str + ' of ' + totalPagesExp
        }
        doc.setFontSize(footerSize);

        var pageSize = doc.internal.pageSize;
        var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

        doc.text(str, 130, pageHeight - 10);
        // jsPDF 1.4+ uses getWidth, <1.4 uses .width


        let currentDate = new Date();
        let ddFormat = (currentDate.getDate() < 10 ? '0' : '') + currentDate.getDate();
        let mmFormat = ((currentDate.getMonth() + 1) < 10 ? '0' : '') + (currentDate.getMonth() + 1);
        let currentDateString = mmFormat + '/' + ddFormat + '/' + currentDate.getFullYear();
        doc.text(currentDateString, 15, pageHeight - 10);
      },
      didDrawCell: function (data) {
        var str = 'Page ' + doc.getNumberOfPages();
        if (pageno != doc.getNumberOfPages()) {
          pageno = doc.getNumberOfPages();
          pagetotal = 0;
        }
      },
      startY: yAxis
    });

    //Start Date and End Date Filter Code Begin
    //Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    //Opens the PDF preview in a new window
    window.open(URL.createObjectURL(doc.output("blob")));
  }

  drawCell(data: any) { }

  getDateAsString(dt: Date): string {
    let dd = (dt.getDate() < 10 ? '0' : '') + dt.getDate();
    let MM = ((dt.getMonth() + 1) < 10 ? '0' : '') + (dt.getMonth() + 1);
    return MM + "/" + dd + "/" + dt.getFullYear();
  }

  addZeroes(num): any {
    // Convert input string to a number and store as a variable.
    var value = Number(num);
    // Split the input string into two arrays containing integers/decimals
    var res = num.split(".");
    // If there is no decimal point or only one decimal place found.
    if (res.length == 1 || res[1].length < 3) {
      // Set the number to two decimal places
      let val = value.toFixed(2);
      return val;
    }
    // Return updated or original number.
    return value;
  }




  exportgearRequestasCSV(): void {
    this.blockUI.start();
    this.gearRequestService.searchGearRequest(
      'SearchGearRequest',
      (this.gearRequestObj.crew) ? this.gearRequestObj.crew : 0,
      (this.gearRequestObj.replaceOrRepair) ? this.gearRequestObj.replaceOrRepair : 0,
      (this.gearRequestObj.lastName) ? this.gearRequestObj.lastName : '',
      (this.gearRequestObj.gearType) ? this.gearRequestObj.gearType : 0,
      (this.gearRequestObj.startDate) ? this.gearRequestObj.startDate : null,
      (this.gearRequestObj.endDate) ? this.gearRequestObj.endDate : null,
      0, 15, true
    ).subscribe((res: GetAllGearRequestModel) => {
      this.gearRequests = res.items;
      this.blockUI.stop();
      this.exportToCSV();
    }, (error: any) => {
      this.gearRequests = [];
      this.blockUI.stop();
    });
  }




  getHeadRows() {
    return [
      {
        crew: 'Crew   ', date: 'Date', lastname: 'Last Name', replacement: 'Does the PPE Gear Need Replacement or Repair?', reason: 'Reason for Requesting Gear',
        gearType: 'PPE Fire Gear Requesting?', email: 'Email Address',
        status: 'Status of your Current Gear you`re replacing'
      }
    ]
  }

  getBody() {
    let rowCount = this.gearRequests.length;
    var body = []
    for (var j = 0; j < rowCount; j++) {
      body.push({
        crew: this.gearRequests[j].crew,
        date: (this.gearRequests[j].requestDate) ? this.gearRequests[j].requestDate : '',
        lastname: (this.gearRequests[j].lastName) ? this.gearRequests[j].lastName : '',
        replacement: (this.gearRequests[j].replacementOrRepair) ? this.gearRequests[j].replacementOrRepair : '',
        reason: (this.gearRequests[j].reason) ? this.gearRequests[j].reason : '',
        gearType: (this.gearRequests[j].gearType) ? this.gearRequests[j].gearType : '',
        email: this.gearRequests[j].email,
        status: this.gearRequests[j].gearStatus
      });
    }
    return body
  }

  exportToCSV() {
    let rowCount = this.gearRequests.length;
    var data = []
    data.push({
      crew: 'Crew   ', date: 'Date', lastname: 'Last Name', replacement: 'Does the PPE Gear Need Replacement or Repair?', reason: 'Reason for Requesting Gear',
      gearType: 'PPE Fire Gear Requesting?', email: 'Email Address',
      status: 'Status of your Current Gear you`re replacing'    });

    for (var j = 0; j < rowCount; j++) {
      data.push({
        crew: this.gearRequests[j].crew,
        date: (this.gearRequests[j].requestDate) ? this.gearRequests[j].requestDate : '',
        lastname: (this.gearRequests[j].lastName) ? this.gearRequests[j].lastName : '',
        replacement: (this.gearRequests[j].replacementOrRepair) ? this.gearRequests[j].replacementOrRepair : '',
        reason: (this.gearRequests[j].reason) ? this.gearRequests[j].reason : '',
        gearType: (this.gearRequests[j].gearType) ? this.gearRequests[j].gearType : '',
        email: this.gearRequests[j].email,
        status: this.gearRequests[j].gearStatus
      });
    }
    new AngularCsv(data, 'Gear Request Report');

  }

}
